import React from 'react';
import { useNavigate } from 'react-router-dom';
import { APP_ROUTES } from '../../constants/appRoutes';

import '../../App.scss';

import EnterEmailSurface from '../../components/EnterEmailSurface';

const EnterEmail = () => {
  const navigate = useNavigate();

  const navigateBack = () => {
    navigate(APP_ROUTES.PHOTO_STYLES_INSTRUCTION);
  };

  return (
    <EnterEmailSurface
      onBack={navigateBack}
      title="You're almost there!"
      text="Just enter your email, and we'll send the assembly instructions right away!"
    />
  );
};

export default EnterEmail;
